import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { ListGroup, ListGroupItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';
import { Creators as StatesCreators } from '../../store/ducks/states';
import { Creators as NewspapersCreators } from '../../store/ducks/newspapers';

class MenuStates extends Component {
  static propTypes = {
    getStatesRequest: PropTypes.func.isRequired,
    getSearch: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = { selectedStateInMenu: null };
  }

  componentWillMount() {
    this.props.getStatesRequest();
    this.onLoadSelectStateValue();
  }

  onLoadSelectStateValue() {
    const url = window.location.href.split('/');
    this.setState({
      selectedStateInMenu: `/jornais/${url[url.length - 1]}`,
    });
  }

  handleChange(event) {
    window.location.replace(event.target.value);
  }

  clickNewspapers = (e, uf) => {
    e.preventDefault();
    this.getNewspapers(uf);
  };

  getNewspapers = (uf) => {
    const params = { uf: uf.toLowerCase(), query: false };
    this.props.getSearch(params);
  };

  render() {
    return (
      <Fragment>
        <select
          className="d-block d-md-none mb-4 w-100 p-3"
          onChange={this.handleChange}
          value={this.state.selectedStateInMenu}
        >
          <option value="/jornais/todos">Todos</option>
          {this.props.states.map(estado => (
            <option value={`/jornais/${estado.uf.toLowerCase()}`} key={estado.uf}>
              {estado.state}
            </option>
          ))}
        </select>

        <div className="d-none d-md-block">
          <ListGroup flush>
            <Link
              className="list-group-item"
              to="/jornais/todos"
              onClick={e => this.clickNewspapers(e, 'todos')}
            >
              Todos
            </Link>
            {this.props.states.map(estado => (
              <Link
                className="list-group-item"
                to={`/jornais/${estado.uf.toLowerCase()}`}
                onClick={e => this.clickNewspapers(e, estado.uf)}
              >
                {estado.state}
              </Link>
            ))}
          </ListGroup>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  states: state.states.states,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ ...StatesCreators, ...NewspapersCreators }, dispatch);

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(MenuStates));



// WEBPACK FOOTER //
// ./src/components/MenuStates/index.js